import {
  Activity,
  ArrowRightLeft,
  Award,
  Banknote,
  BookOpen,
  GitBranch,
  Globe,
  MapPin,
  Store,
  BadgeAlert,
  BarChart3,
  Boxes,
  Briefcase,
  Building,
  Building2,
  Calculator,
  CalendarClock,
  CalendarDays,
  CalendarX,
  Clock,
  CandlestickChart,
  Coins,
  CreditCard,
  Eye,
  Factory,
  Fingerprint,
  FileText,
  Folder,
  FolderInput,
  FolderTree,
  Gauge,
  Handshake,
  Heart,
  History,
  Home,
  KeyRound,
  Flag,
  Landmark,
  Map,
  Layers,
  Library,
  LineChart,
  ListChecks,
  ListPlus,
  ListOrdered,
  ListTree,
  type LucideIcon,
  MessageCircle,
  Network,
  Percent,
  PieChart,
  Receipt,
  Repeat,
  Scale,
  ScrollText,
  Search,
  Settings,
  Shapes,
  ShieldCheck,
  SlidersHorizontal,
  SquarePen,
  Sunrise,
  Tags,
  TrendingUp,
  Upload,
  Users,
  Wallet,
  Waypoints,
  Workflow,
  Wrench,
  Zap,
} from 'lucide-react';

// Allow-list of icons referenced by the Pages table's `iconName` column.
// Unknown names → graceful no-icon + console.warn (once per unique name).
// To add support for a new icon, add it both to the import and to ICON_MAP.
const ICON_MAP: Record<string, LucideIcon> = {
  BookOpen,
  Activity,
  ArrowRightLeft,
  Award,
  Banknote,
  GitBranch,
  Globe,
  MapPin,
  Store,
  BadgeAlert,
  BarChart3,
  Boxes,
  Briefcase,
  Building,
  Building2,
  Calculator,
  CalendarClock,
  CalendarDays,
  CalendarX,
  Clock,
  CandlestickChart,
  Coins,
  CreditCard,
  Eye,
  Factory,
  Fingerprint,
  FileText,
  Folder,
  FolderInput,
  FolderTree,
  Gauge,
  Handshake,
  Heart,
  History,
  Home,
  KeyRound,
  Flag,
  Landmark,
  Map,
  Layers,
  Library,
  LineChart,
  ListChecks,
  ListPlus,
  ListOrdered,
  ListTree,
  MessageCircle,
  Network,
  Percent,
  PieChart,
  Receipt,
  Repeat,
  Scale,
  ScrollText,
  Search,
  Settings,
  Shapes,
  ShieldCheck,
  SlidersHorizontal,
  SquarePen,
  Sunrise,
  Tags,
  TrendingUp,
  Upload,
  Users,
  Wallet,
  Waypoints,
  Workflow,
  Wrench,
  Zap,
};

const warnedNames = new Set<string>();

export function resolveIcon(
  iconName: string | null | undefined,
): LucideIcon | null {
  if (!iconName) return null;
  const icon = ICON_MAP[iconName];
  if (!icon) {
    if (!warnedNames.has(iconName)) {
      warnedNames.add(iconName);
      // eslint-disable-next-line no-console
      console.warn(
        `[Sidebar] Unknown iconName "${iconName}" from /api/pages — rendering no icon. Add it to ICON_MAP in sidebarIcons.ts if needed.`,
      );
    }
    return null;
  }
  return icon;
}
